<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row justify-between align-center">
    @if (canais.length > 0) {
      <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" classe="pesquisar" backgroundColor="transparent"
                      widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" (changeValue)="filtrarGrupos($event)"></app-form-field>
    }
  </div>

  @if (canais.length > 0 && !carregandoCanais) {
    <mat-table [dataSource]="canaisDataSource">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
              widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
              widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.nome || '' }}">
          <p class="ellipse">{{ elemento?.nome || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <mat-header-cell *matHeaderCellDef> Descricao </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.descricao || '' }}">
          <p class="ellipse">{{ elemento?.descricao || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento?.ativo ? 'Ativo' : 'Inativo' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="privado">
        <mat-header-cell *matHeaderCellDef style="text-align: center;"> Privado? </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.privado ? 'Sim' : 'Não' }}">
          <p class="ellipse">{{ elemento?.privado ? 'Sim' : 'Não' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="externo">
        <mat-header-cell *matHeaderCellDef style="text-align: center;"> Externo? </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.externo ? 'Sim' : 'Não' }}">
          <p class="ellipse">{{ elemento?.externo ? 'Sim' : 'Não' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuCriacao">
        <mat-header-cell *matHeaderCellDef> Usuário Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento?.usuarioCriacao?.nome || '--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef> Data Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ (elemento?.dataCriacao | date:'dd/MM/yyyy') || '--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell *matHeaderCellDef> Usu. Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento?.usuarioAlteracao?.nome || '--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef> Data Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ (elemento?.dataAlteracao | date:'dd/MM/yyyy') || '--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="qtdOperadores">
        <mat-header-cell *matHeaderCellDef> Qtd Operadores </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento?.operadores?.length || 0 }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="qtdTemplates">
        <mat-header-cell *matHeaderCellDef> Templates </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento?.templates?.length || 0 }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="coordenadores">
        <mat-header-cell *matHeaderCellDef> Coordenadores </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-row align-center gap-5">
            @for (coordenador of elemento.coordenadores; track coordenador.id){
              @if (coordenador.extensaoImg && coordenador.uuid){
                <img class="icones circulo" [matTooltip]="coordenador.nome" [src]="gerarUrl(coordenador.uuid, coordenador.extensaoImg, 'usuario-img')" [alt]="'Foto de ' + coordenador.nome" />
              } @else {
                <img class="icones" [matTooltip]="coordenador.nome" src="./assets/icones/no-img-default.png" alt="" />
              }
            }
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  }@else if(canais.length <= 0 && !carregandoCanais){
    <div style="text-align: center; width: 100%;">
      <mat-icon style="margin: 10px;">error_outline</mat-icon>
      <p>Nenhum registro foi encontrado</p>
    </div>
  }@else if(carregandoCanais){
    <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
  }
  @if (canais.length === 0 && canaisCarregados) {
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhum canal encontrado">
    </div>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar canal" tabindex="0" role="button" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)" />
</div>
